module.exports = __webpack_public_path__ + "static/img/contant_5.0722a7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_8/contant_5.jpg
// module id = C4ZP
// module chunks = 0